// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A76hmi {
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  padding: var(--spacing-3);
  margin-bottom: var(--spacing-2);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.uaPVR2 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.JVWx1y {
  display: flex;
  flex-direction: column;
}

.XzBiHe {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-3);
}

.Hx68q5 {
  border-top-color: var(--separator-color);
  margin: 0;
}

.rY2paB {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: left;
}

.FmYRYM {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  text-align: right;
}

.qRPhKt {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
}

.Arud9P {
  font-size: var(--font-size-lg);
  line-height: var(--line-height-100);
  text-align: left;
}

.JziVxb {
  width: var(--spacing-3);
  height: var(--spacing-3);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.JziVxb img {
  height: var(--spacing-1-5);
  width: var(--spacing-1-5);
}

.okoXf2 {
  gap: var(--spacing-0-5);
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.XZv4NM {
  align-items: flex-end;
}

.L4XPKP {
  position: relative;
}

.LmxWoT {
  margin-top: -15px;
  margin-left: 15px;
}

.qEYEuV {
  opacity: 0.3;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeDetailsModal/components/ProductInfo/ProductInfo.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-3);\n  margin-bottom: var(--spacing-2);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.infoGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.infoProductRow {\n  display: flex;\n  flex-direction: column;\n}\n\n.infoRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--spacing-3);\n}\n\n.separator {\n  border-top-color: var(--separator-color);\n  margin: 0;\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.value {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  text-align: right;\n}\n\n.valueWithAction {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.infoProductValue {\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-100);\n  text-align: left;\n}\n\n.iconButton {\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.iconButton img {\n  height: var(--spacing-1-5);\n  width: var(--spacing-1-5);\n}\n\n.downloadButton {\n  gap: var(--spacing-0-5);\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.infoRowBottomAlign {\n  align-items: flex-end;\n}\n\n.buttonWithCalendar {\n  position: relative;\n}\n\n.calendarDatePicker {\n  margin-top: -15px;\n  margin-left: 15px;\n}\n\n.loadingValue {\n  opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `A76hmi`,
	"infoGroup": `uaPVR2`,
	"infoProductRow": `JVWx1y`,
	"infoRow": `XzBiHe`,
	"separator": `Hx68q5`,
	"label": `rY2paB`,
	"value": `FmYRYM`,
	"valueWithAction": `qRPhKt`,
	"infoProductValue": `Arud9P`,
	"iconButton": `JziVxb`,
	"downloadButton": `okoXf2`,
	"infoRowBottomAlign": `XZv4NM`,
	"buttonWithCalendar": `L4XPKP`,
	"calendarDatePicker": `LmxWoT`,
	"loadingValue": `qEYEuV`
};
module.exports = ___CSS_LOADER_EXPORT___;
